import { TextField } from "@/components/forms/fields";
import { containerVerticalFlowAnalytics } from "../analytics";
import { StandardContainer } from "@/components/Common/StandardContainer/StandardContainer";
import { SectionHeader } from "@/components/Common/SectionHeader/SectionHeader";
import { RequiredIndicator } from "@/components/Common/RequiredIndicator/RequiredIndicator";

type CustomizeContainerStepProps = {
  onNameChange: () => void;
};

export const CustomizeContainerStep: React.FC<CustomizeContainerStepProps> = ({ onNameChange }) => {
  return (
    <StandardContainer className="flex flex-col gap-6">
      <SectionHeader
        title="Customize Your Container"
        subtitle="Change your container name"
        savedInConfig
      />
      <div className="flex flex-1 flex-col gap-6 border border-border rounded-lg py-2.5 px-4">
        <div className="flex flex-col gap-[6px]">
          <div className="flex items-center gap-1 text-sm font-normal leading-5 text-foreground">
            Container Name
            <RequiredIndicator />
          </div>
          <TextField
            name="name"
            placeholder="my-caas-deployment"
            baseHOCClassName="pb-0"
            className="w-full placeholder:text-gray-dark-2200"
            onFocus={onNameChange}
            onBlur={() => containerVerticalFlowAnalytics.trackContainerNameFilled()}
          />
        </div>
      </div>
    </StandardContainer>
  );
};
